import { Box, Container, Typography } from "@mui/material";
import React from "react";

const RefundPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
     <Typography
  className="landing-bg_biggpay_font"
  sx={{
    fontWeight: 700,
    textAlign: "center",
    fontSize:"28px",
    width: "100%",
    mb: 2,
  }}
>
  Refund Policy
</Typography>

      <Box
  sx={{
    width:180,
    height: 8,
    bgcolor: "#dc5f5f",
    mx: "auto",
    mb: 4,
    borderRadius: 2,
  }}
/>

      <Typography className="landing-bg_para" paragraph>
        <strong>1. Transaction Finality &amp; User Responsibility</strong>
        <br />
        All sales, bill payments, and recharges processed through our platform
        are final and non-refundable. Exchanges are not permitted.
        <br />
        <br />
        You (the customer or agent) are solely responsible for verifying the
        accuracy of all input details—including mobile numbers, DTH account IDs,
        utility reference numbers, and any other required identifiers—before
        completing a transaction.
      </Typography>

      <Typography className="landing-bg_para" paragraph>
        <strong>2. Limitation of Liability</strong>
        <br />
        <strong>INSTAMOTION SOLUTION PRIVATE LIMITED</strong> bears no liability
        for transactions that are processed using incorrect, mistyped, or
        inaccurate identification details provided by you.
        <br />
        <br />
        <strong>Important:</strong> Errors made by the user (such as entering
        the wrong number) are not eligible for refunds under any circumstances.
      </Typography>

      <Typography className="landing-bg_para" paragraph>
        <strong>3. Reporting Failed Transactions (Non-Delivery)</strong>
        <br />
        If a transaction (purchase, bill payment, or recharge) made via your
        Wallet on our Site is not successfully delivered within 72 hours of
        completion, you may report the issue by emailing our customer support
        team (address available on our Contact Us page).
        <br />
        <br />
        Your email must include the following details:
      </Typography>

      <Box component="ul" sx={{ pl: 4, mb: 3 }}>
        <li>
          <Typography className="landing-bg_para">
            The mobile number, DTH account ID, or utility reference number
            used.
          </Typography>
        </li>
        <li>
          <Typography className="landing-bg_para">
            The relevant operator/service provider name(s).
          </Typography>
        </li>
        <li>
          <Typography className="landing-bg_para">
            The order number associated with the transaction.
          </Typography>
        </li>
      </Box>

      <Typography className="landing-bg_para" paragraph>
        <strong>4. Investigation &amp; Refund Timeline</strong>
        <br />
        Upon receiving your email, we will conduct a formal investigation.
        <br />
        <br />
        If we confirm that your card, bank account, or Wallet was successfully
        charged but the intended service was not delivered, we will process a
        full refund. This refund will be credited to your Wallet/account within
        <strong> 21 working days</strong> from the date we receive your valid
        email notification.
      </Typography>

      <Typography className="landing-bg_para" paragraph>
        <strong>5. Account Suspension &amp; Termination</strong>
        <br />
        <strong>INSTAMOTION SOLUTION PRIVATE LIMITED</strong> reserves the
        right, at its sole discretion and without penalty, to suspend or
        permanently terminate your account (or any part thereof) or your access
        to the Services at any time. We may do so with or without prior notice
        and with or without cause.
      </Typography>

      <Typography className="landing-bg_para" paragraph>
        <strong>6. Post-Termination Actions</strong>
      </Typography>

      <Box component="ul" sx={{ pl: 4, mb: 3 }}>
        <li>
          <Typography className="landing-bg_para">
            Upon termination, you must immediately cease using our Services.
          </Typography>
        </li>
        <li>
          <Typography className="landing-bg_para">
            We reserve the right to refer any suspected fraudulent, abusive, or
            illegal activity associated with your account to the appropriate law
            enforcement authorities.
          </Typography>
        </li>
        <li>
          <Typography className="landing-bg_para">
            These remedies are in addition to any other legal or equitable
            remedies available to us.
          </Typography>
        </li>
      </Box>

      <Typography className="landing-bg_para" paragraph>
        <strong>7. Settlement of Wallet Balance</strong>
        <br />
        In the event of account termination, any outstanding balance remaining
        in your Wallet will be refunded to you strictly in accordance with the
        prevailing Reserve Bank of India (RBI) guidelines.
      </Typography>
    </Container>
  );
};

export default RefundPolicy;